import { render, staticRenderFns } from "./BundleDetails.vue?vue&type=template&id=2364bde7&scoped=true&"
import script from "./BundleDetails.vue?vue&type=script&lang=js&"
export * from "./BundleDetails.vue?vue&type=script&lang=js&"
import style0 from "./BundleDetails.vue?vue&type=style&index=0&id=2364bde7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2364bde7",
  null
  
)

export default component.exports